<template>
  <el-table
    class="el-table--request"
    :data="mData.dataDefault.listEmployeeRequests"
    style="width: 100%"
    max-height="550"
    border
    :stripe="false"
    row-class-name="row-class"
  >
    <el-table-column
      label="Loại yêu cầu"
      width="150"
    >
      <template slot-scope="scope">
        {{
          scope.row.type == 'DAY_OFF' ? 'Xin nghỉ' :
          scope.row.type == 'GO_LATE' ? 'Đi muộn' :
          scope.row.type == 'COME_BACK_SOON' ? 'Về sớm' :
          scope.row.type == 'WORK_EXPLANATION' ? 'Giải trình công' :
          scope.row.type == 'GO_OUT' ? 'Ra ngoài' :
          scope.row.type == 'GO_ON_BUSSINESS' ? 'Công tác' :
          scope.row.type == 'TIME_KEEPING_ONLINE' ? 'Chấm công online' :
          scope.row.type == 'WIFI_ATTENDANCE' ? 'Điểm danh thủ công' :
          scope.row.type == 'OT' ? 'Làm thêm' : ''
        }}
      </template>
    </el-table-column>
    <el-table-column
      prop="content"
      label="Nội dung"
      width="width"
    >
    </el-table-column>
    <el-table-column
      label="Thời gian"
      align="center"
      width="150"
    >
      <template slot-scope="scope">
        {{ formatDateTime(scope.row.created_at) }}
      </template>
    </el-table-column>
    <el-table-column
      label="Trạng thái"
      align="center"
      width="150"
    >
      <template slot-scope="scope">
        <span
          :class="{
            status: true,
            'waiting-for-approval': scope.row.status == 'WAITING_FOR_APPROVAL',
            'approved': scope.row.status == 'APPROVED',
            'rejected': scope.row.status == 'REJECTED',
          }"
        >
          {{
            scope.row.status == 'WAITING_FOR_APPROVAL' ? 'Đang chờ duyệt' :
            scope.row.status == 'APPROVED' ? 'Đã duyệt' :
            scope.row.status == 'REJECTED' ? 'Từ chối' : ''
          }}
        </span>
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      label="Hành động"
      width="100"
    >
      <template slot-scope="scope">
        <el-button
          class="button-action detail"
          v-b-popover.hover.left="'Chi tiết'"
          @click="fn_handle('detail', scope.row.id)"
        >
          <i class="icon icon24-EyeOn"></i>
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import MethodService from '@/service/MethodService'
import EmployeeRequestApi from '@/moduleApi/EmployeeRequestApi'
export default {
    props: {
      time: {
        type: Date,
        default: new Date
      }
    },
    data() {
      return {
        mData: {
          firstDayInMonth: MethodService.getFirstDayOfMonth(this.time),
          lastDayInMonth: MethodService.getLastDayOfMonth(this.time),
          currentUser: MethodService.getCurrentUser(),
          dataDefault: {
            listEmployeeRequests: [],
          }
        }
      }
    },
    methods: {
      // A method that is being called in the Vue HTML.
      async getListRequest() {
        const employeeRequestApiRes = await EmployeeRequestApi.list({
          filters: `employee_id=${this.mData.currentUser.id}`,
          sort: '-created_at',
          limit: 10
        })
        this.mData.dataDefault.listEmployeeRequests = employeeRequestApiRes.result.filter(
          (e) => e.employee_id == this.mData.currentUser.id
        )
      },
      fn_handle(type, id) {
        if (type == 'detail') {
          this.$router.push({
            name: 'Admin-ManageRequests-CheckRequest',
            params: { id: id }
          })
        }
      },
      // A method that is being called in the Vue HTML.
      formatDateTime(value) {
        return MethodService.formatDate(value, 'aboutTime')
      },
    },
    created() {
      this.getListRequest()
    }
}
</script>
<style lang="scss" scoped>
::v-deep .row-class {
    background-color: #FFF !important;
}
.status {
    font-family: 'LexendDeca Regular';
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    &.waiting-for-approval{
        color: #FFA800;
    }
    &.approved{
        color: #4F8AAB;
    }
    &.rejected{
        color: #F12727;
    }
}

.button-action {
    width: 22px;
    border: none;
    padding: 0;
    background: transparent;
    &.detail {
        color: #1E3CD7;
        &:hover {
            color: #1E3CD7;
        }
    }
}
</style>
<style lang="scss">
.el-table.el-table--request {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    thead {
        tr {
            th {
                background: #4F8AAB !important;
            }
        }
    }
}
</style>
